import axios from "axios";
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `${config?.URL_INVOICES}/od`;
const URL_SAT = `${config?.URL_SAT}/od`;

// Función auxiliar para manejar las solicitudes HTTP
const request = async (method, url, data = null, isSat = false) => {
  const baseURL = isSat ? URL_SAT : BASE_URL;
  const endpoint = `${baseURL}${url}`;

  try {
    const headers = await headers_get();
    return await axios({ method, url: endpoint, data, headers });
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} ${endpoint}:`, error?.response?.data || error.message);
    throw error;
  }
};


// 🔹 Gestión de Conceptos
export const concepts_get = async () => request("get", "/concepts");
export const concepts_post = async (data) => request("post", "/concepts", data);
export const concepts_put = async (id, data) => request("put", `/concepts/${id}`, data);
export const concepts_delete = async (id) => request("delete", `/concepts/${id}`);

// 🔹 Gestión de Impuestos en Conceptos

export const concept_taxes_config_get = (id) => request("get", `/taxes/configs`);



export const concepts_taxes_get = async (id) => request("get", `/concepts/${id}/taxes`);
export const concepts_taxes_post = async (id, data) => request("post", `/concepts/${id}/taxes`, data);
export const concepts_taxes_put = async (id, idt, data) => request("put", `/concepts/${id}/taxes/${idt}`, data);
export const concepts_taxes_delete = async (id, idt) => request("delete", `/concepts/${id}/taxes/${idt}`);




// 🔹 Gestión de Códigos SAT
export const get_category_sat = async () => request("get", "/sat_category_codes", null, true);
export const get_section_sat = async (section) => request("get", `/sat_category_codes/sections?category=${section}`, null, true);
export const get_section_codes_sat = async (id) => request("get", `/sat_category_codes/sections/codes?id=${id}`, null, true);
export const get_unit_codes_sat = async () => request("get", "/sat_units_codes", null, true);


export const concepts_calculate = async (data) => {
  const url = `${BASE_URL}/od/concepts/calculate`;
  try {
    const headers = await headers_get();
    const response = await axios.post(url, data, {
      headers: headers,
    });
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};
